<div class="root-div">
  <button
    type="button"
    pButton
    class="p-button-text p-button-plain custom-icon-button tool-bar-pbutton"
    [disabled]="!isIntelliCatchFullyEnabled"
    [class.disabled]="!isIntelliCatchFullyEnabled"
    (click)="isIntelliCatchFullyEnabled ? toggleChatbot() : null"
    pTooltip="{{ getTooltipMessage() }}"
    tooltipPosition="bottom">
    <span class="material-symbols-outlined chatbot-icon">robot_2</span>
    @if (isResultsReady && isIntelliCatchFullyEnabled) {
      <span class="results-ready-dot"></span>
    }
  </button>
</div>
